import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2B335B",
      d: "M7.404 13.16a.92.92 0 0 0 0-1.299L3.17 7.635h21.683a.92.92 0 0 0 0-1.841H3.197l4.207-4.208A.928.928 0 1 0 6.098.269L.241 6.134a.829.829 0 0 0 0 1.17l5.856 5.855a.92.92 0 0 0 1.307 0Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "return"}) } }